import { type AvailableSlot } from '@/api';

interface TimeSlotPickerProps {
  slots: AvailableSlot[];
  selectedSlotId: string | null;
  onSelectSlot: (slotId: string) => void;
  isLoading?: boolean;
}

export function TimeSlotPicker({
  slots,
  selectedSlotId,
  onSelectSlot,
  isLoading = false,
}: TimeSlotPickerProps) {
  if (isLoading) {
    return (
      <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-2">
        {Array.from({ length: 8 }).map((_, index) => (
          <div key={index} className="h-10 bg-muted/60 rounded-xl animate-pulse" />
        ))}
      </div>
    );
  }

  if (!Array.isArray(slots) || slots.length === 0) {
    return (
      <div className="p-6 text-center border border-dashed border-border rounded-xl">
        <p className="text-sm text-muted-foreground">
          Nenhum horário disponível para esta data.
        </p>
      </div>
    );
  }

  const formatTime = (time?: string): string => {
    if (!time) return '--:--';
    const parts = time.split(':');
    return `${parts[0] || '00'}:${parts[1] || '00'}`;
  };

  return (
    <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-2.5">
      {slots.filter(Boolean).map((slot) => {
        const isSelected = slot.id === selectedSlotId;
        const isAvailable = slot.available;

        return (
          <button
            key={slot.id}
            type="button"
            onClick={() => isAvailable && onSelectSlot(slot.id)}
            disabled={!isAvailable}
            className={`
              px-3.5 py-2.5 rounded-xl text-xs sm:text-sm font-semibold transition-all duration-150 select-none
              ${
                isSelected
                  ? 'bg-primary text-primary-foreground font-bold shadow-md shadow-primary/25 scale-[1.03]'
                  : isAvailable
                  ? 'bg-card border border-border text-foreground hover:border-primary/50 hover:bg-primary/5 hover:text-primary cursor-pointer hover:scale-[1.02]'
                  : 'bg-muted/30 text-muted-foreground/40 opacity-60 cursor-not-allowed border border-transparent'
              }
            `}
          >
            {formatTime(slot?.startTime)}
          </button>
        );
      })}
    </div>
  );
}
